import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import Fuse from 'fuse.js';

import toast from 'components/common/toast';
import Loader from 'components/common/loader';
import MainLayout from 'components/templates/main-layout';

import LocationFinder from './components/location-finder';
import LocationForm from './components/location-form';
import EmptyLayout from './components/empty-layout';

import { GET_ENABLED_LOCATIONS, GET_LATEST_VERSION, GET_OPEN_REPORT } from './requests';
import LoaderContainer from './elements';

const fuzzySearchOptions = {
  shouldSort: true,
  threshold: 0.1,
  location: 0,
  distance: 100,
  maxPatternLength: 64,
  minMatchCharLength: 3,
  keys: ['location.tag'],
};

class LocationCount extends Component {
  state = {
    slide: 1,
    locationSearch: '',
    loading: true,
    error: false,
    errorMessage: '',
    location: {},
    enabledLocations: [],
    locationsFiltered: [],
    latestProducts: [],
    openReport: {},
  };

  componentDidMount = async () => {
    this.getEnabledLocations();
    this.getOpenReport();
  };

  componentDidUpdate = (_, prevState) => {
    const { slide } = this.state;

    if (prevState.slide !== slide && slide === 1) {
      this.getEnabledLocations();
    }
  };

  changeSlide = slide => this.setState({ slide });

  clearInput = () => this.setState({ locationSearch: '', loadingLocation: false });

  setLocation = async location => {
    if (location.versions >= 2) {
      await this.getLatestVersion(location);
    }

    this.setState({ location, slide: 2 });
  };

  handleLocationSearch = event => {
    const { enabledLocations } = this.state;
    const {
      target: { value },
    } = event;

    const fuse = new Fuse(enabledLocations, fuzzySearchOptions);

    const locationsFiltered = fuse.search(value);

    this.setState({ locationSearch: value, locationsFiltered });
  };

  getEnabledLocations = async () => {
    const { client } = this.props;

    const { data, errors } = await client.query({
      query: GET_ENABLED_LOCATIONS,
    });

    if (errors) {
      toast.error('Algo salió mal, intentalo de nuevo');
      this.setState({ loading: false });
      return;
    }

    const { enabledLocations } = data;

    this.setState({ enabledLocations, loading: false });
  };

  getOpenReport = async () => {
    const { client } = this.props;

    let openReport = {};

    const { data } = await client.query({
      query: GET_OPEN_REPORT,
    });

    if (data) {
      openReport = data.openReport;
    }

    this.setState({ openReport })
  }

  getLatestVersion = async location => {
    const { client } = this.props;

    this.setLoading(true);

    const { data } = await client.query({
      query: GET_LATEST_VERSION,
      variables: { tag: location.location.tag },
    });

    if (data && data.incidences) {
      const { incidences } = data;

      const products = incidences.map(product => {
        const { productCode, upc, pieces: piecesPerBox, expiryDate, batch } = product;

        return { productCode, upc, piecesPerBox, expiryDate, batch };
      });

      this.setState({ latestProducts: products });
    }

    this.setLoading(false);
  };

  clearLatestProducts = () => this.setState({ latestProducts: [] });

  setLoading = bool => this.setState({ loading: bool });

  render() {
    const { client } = this.props;

    const {
      slide,
      locationSearch,
      location,
      enabledLocations,
      locationsFiltered,
      loading,
      latestProducts,
      openReport,
    } = this.state;

    const isEmpty = enabledLocations.length === 0;

    return (
      <MainLayout>
        {loading && (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        )}
        {!loading && (
          <Fragment>
            {isEmpty && <EmptyLayout />}
            {!isEmpty && (
              <Fragment>
                {slide === 1 && (
                  <LocationFinder
                    handleInput={this.handleLocationSearch}
                    value={locationSearch}
                    enabledLocations={enabledLocations}
                    locationsFiltered={locationsFiltered}
                    setLocation={this.setLocation}
                  />
                )}

                {slide === 2 && (
                  <LocationForm
                    client={client}
                    changeSlide={this.changeSlide}
                    clearLatestProducts={this.clearLatestProducts}
                    setLoading={this.setLoading}
                    location={location}
                    latestProducts={latestProducts}
                    openReport={openReport}
                  />
                )}
              </Fragment>
            )}
          </Fragment>
        )}
      </MainLayout>
    );
  }
}

export default withApollo(LocationCount);
